import React, { useCallback, useRef } from 'react'
import { NavLink } from 'react-router-dom';
import { adminProgrammeAddLink, adminProgrammeDetailsLink, adminProgrammeEditLink } from '../../constants/endspoints';
import { fetchPrograms } from '../../api/programmation';
import { useInfiniteQuery } from '@tanstack/react-query';
import IsEmpty from '../../components/IsEmpty';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';

const Programmation = () => {


    // Fetch All Programs
    const { data: programsList, fetchNextPage, hasNextPage, isFetchingNextPage, status: listStatus } = useInfiniteQuery({
        queryKey: ["program"],
        queryFn: fetchPrograms,
        getNextPageParam: (lastPage) => lastPage.nextPage,
        retry: 2,
    });


    const observer = useRef();
    const lastMediaRef = useCallback((node) => {
        if (isFetchingNextPage) return;
        if (!hasNextPage) return;

        if (observer.current) observer.current.disconnect();

        observer.current = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                fetchNextPage(); 
            }
        });

        if (node) observer.current.observe(node);
    }, [isFetchingNextPage, hasNextPage, fetchNextPage]);

    return (
        <div>
            <h1 className='fs-3 fw-bold mb-3'>Programmation TV</h1>

            <div className='bg-black rounded-3 p-2 shadow'>
                <h2 className='fs-5 fw-bold mb-2'>Liste des Programmations</h2>

                <div className="d-flex justify-content-start align-items-center my-3 menu">
                    <NavLink to={adminProgrammeAddLink} className='d-flex align-items-center w-auto px-2 py-1 me-2 mb-2 nav-link border bordercolor-primary rounded-3'>
                        <i className="fa-light fa-square-plus me-2 text-white"></i>
                        <span className=' fs-9s text-white'>Ajouter une programmation</span>
                    </NavLink>
                </div>


                {/* Liste */}
                <div className='mt-4 pt-2 table-responsive'>
                    <table className='table table-dark table-striped table-hover fs-9s align-middle'>
                        <thead>
                            <tr>
                                <th className='fs-9s'>#</th>
                                <th className='fs-9s'>Jour</th>
                                <th className='fs-9s'>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                        {listStatus === "pending" ?
                            [1,2,3,4,5].map((item, index) => (
                                <tr key={index}>
                                    <td className='fs-9s py-1 placeholder-wave'><i className='placeholder col-12 bgcolor-primary'></i></td>
                                    <td className='fs-9s py-1 placeholder-wave'><i className='placeholder col-12 bgcolor-primary'></i></td>
                                    <td className='fs-9s py-1 placeholder-wave'><i className='placeholder col-12 bgcolor-primary'></i></td>
                                </tr>
                            ))
                            : listStatus === "error" ? 
                                <tr>
                                    <td  colSpan="3" className='w-100'>
                                        <IsEmpty icon={"fa-light fa-circle-exclamation"} message={"Une erreur est survenue"} />
                                    </td>
                                </tr>
                            :programsList?.pages?.flatMap((page, pageIndex) => 
                                ((programsList?.pages?.length <= 1) && !page?.nextPage) ?
                                    <tr>
                                        <td  colSpan="3" className='w-100'>
                                            <IsEmpty icon={"fa-light fa-list-timeline"} message={"Aucune émission enregistrée"} />
                                        </td>
                                    </tr>
                                :page?.data?.map((program, index) => {
                                    const isLastItem = pageIndex === programsList?.pages?.length - 1 && index === page?.data?.length - 1;
                                    return (
                                        <tr key={program.id} ref={isLastItem ? lastMediaRef : null}>
                                            <td className='py-1 fs-9s fw-bold'>{index+1}</td>
                                            <td className='py-1 '><span className='text-truncate-1 fs-9s text-capitalize'>{format(new Date(program.dayAt), "EEE, dd MMM yyyy", {locale: fr})}</span></td>
                                            <td className='py-1 fs-9s'>
                                                <div className=' d-flex flex-nowrap'>
                                                    <NavLink to={adminProgrammeDetailsLink+'/'+program.id} title='see' className='fa-light fa-eye fs-9s text-success me-2'></NavLink>
                                                    <NavLink to={adminProgrammeEditLink+'/'+program.id} title='modify' className='fa-light fa-edit fs-9s text-info me-2'></NavLink>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })
                            )
                        }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default Programmation